import { escapeSingleDoubleQuotesAndBackSlash } from '../edge-server/utils/escapeSingleDoubleQuotesAndBackslash';

export const mapEQLValues = (values: string[]): string => {
  return values.map(escapeSingleDoubleQuotesAndBackSlash).join(', ');
};
